module.exports = __webpack_public_path__ + "img/contentImg3.eee169a.png";